export default __webpack_public_path__ + "static/media/memoji-2.03a50271.png";